import * as React from 'react';
import styles from './Tabs.module.scss';
import getTabId from './getTabId';

export interface PanelProps extends React.PropsWithChildren {
	readonly name: string;
	readonly hidden?: boolean;
}

export const Panel: React.FunctionComponent<PanelProps> = ({ name, hidden, children }) => {
	const tabId = getTabId(name);

	return (
		<div
			className={styles.panel}
			role="tabpanel"
			tabIndex={0}
			id={`${tabId}-tab`}
			aria-labelledby={tabId}
			hidden={hidden}
		>
			{children}
		</div>
	);
};
